import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpRightFromSquareRound = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.757 5a1 1 0 0 1 1-1h6.24a1 1 0 0 1 1 1v6.24a1 1 0 1 1-2 0V7.414l-6.33 6.331a1 1 0 1 1-1.415-1.414L16.584 6h-3.826a1 1 0 0 1-1-1ZM9.548 7.882a1 1 0 0 1-1 1l-1.94.002A.608.608 0 0 0 6 9.49v7.901c0 .336.272.608.608.608h7.9a.608.608 0 0 0 .608-.608v-1.94a1 1 0 0 1 2 0v1.94A2.608 2.608 0 0 1 14.508 20h-7.9A2.608 2.608 0 0 1 4 17.392v-7.9a2.608 2.608 0 0 1 2.606-2.608l1.941-.002a1 1 0 0 1 1.001 1Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpRightFromSquareRound);
export default Memo;
